import { ReferenceToSubmit } from 'features/References/types/referenceTypes';
import { BaseNimbleAPI } from './baseAPI';

class referenceCheckV2API extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/v2/referencechecks' };
  }

  async create(reference: ReferenceToSubmit | FormData) {
    const response = await this.post('/', reference);
    return response.data;
  }

  async edit(referenceId: number, reference: ReferenceToSubmit | FormData) {
    const response = await this.put(`/${referenceId}/`, reference);
    return response.data;
  }
}

export default new referenceCheckV2API();
